module.exports = __webpack_public_path__ + "static/media/logo.a00925e7.svg";